import React, { useEffect, useState } from 'react';

import Section from '/react4xp/components/Section';
import Button from '/react4xp/components/Button';

interface Props {
    heading?: string,
    message: string,
    cta?: {
       label: string,
       url: string,
    },
 }

export default function ErrorPage(props: Props) {

    const {heading, message, cta} = props

    const svg = <svg width="190" height="204" viewBox="0 0 190 204" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M186.782 201.382V70.8133H152.804V36.605H67.8584V201.382" fill="#F8F3EE" />
        <path d="M186.782 201.382V70.8133H152.804V36.605H67.8584V201.382H186.782Z" stroke="#002855" strokeWidth="4.61758" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M152.804 70.8133H186.782L152.804 36.7685V70.8133Z" fill="#C0DDFF" stroke="#002855" strokeWidth="4.61758" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M68.0756 104.858C96.224 104.858 119.043 81.9945 119.043 53.7909C119.043 25.5872 96.224 2.7236 68.0756 2.7236C39.9272 2.7236 17.1084 25.5872 17.1084 53.7909C17.1084 81.9945 39.9272 104.858 68.0756 104.858Z" fill="#EDE1D4" stroke="#D42702" strokeWidth="4.61758" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M27.8184 85.0849L5.09386 107.854C2.59306 110.36 2.59306 114.391 5.09386 116.869C7.59465 119.375 11.6177 119.375 14.0913 116.869L36.8158 94.0999C35.1577 92.7926 33.5539 91.4036 32.0317 89.8784C30.5095 88.3532 29.1232 86.7463 27.8184 85.0849Z" stroke="#D42702" strokeWidth="4.61758" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M33.5269 39.4648C37.1965 30.6131 44.2096 23.1505 53.7506 19.2013" stroke="#D42702" strokeWidth="4.61758" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M67.8584 91.2402V36.605H101.239" stroke="#002855" strokeWidth="4.61758" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M27.8183 85.0849L21.1042 91.8121L30.1017 100.827L36.8157 94.0999C35.1576 92.7926 33.5538 91.4036 32.0316 89.8784C30.5094 88.3532 29.1231 86.7463 27.8183 85.0849Z" stroke="#D42702" strokeWidth="4.61758" strokeLinecap="round" strokeLinejoin="round" />
    </svg>;

    const [isMobile, setIsMobile] = useState<boolean>(false)

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth

            if (width < 768) {
                setIsMobile(true)
            } else {
                setIsMobile(false)
            }
        }

        handleResize()

        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return (
        <main className="standard-main">
            <Section bgColor='bg-beige-050'>
               <div className="error">
                  <div className="grid-container">
                     <div className="grid-row">
                        <div className="c-md-10 start-md-2">
                           <div className="error__wrapper">

                              <figure className="error__image">
                                 {svg}
                              </figure>
                              <div className="error__content">
                                 <div className="message">
                                    {heading && <h1 dangerouslySetInnerHTML={{ __html: heading }} suppressHydrationWarning></h1>}
                                    {message && <p>{message}</p>}
                                 </div>
                                 {cta && <div className="cta">
                                    <Button className='btn btn--primary btn--icon' rightIcon='ArrowRight' size={isMobile ? 'sm' : 'lg'} href={cta.url}>
                                       {cta.label}
                                    </Button>
                                 </div>}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </Section>
        </main>
    )
}